// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep mat-card.org-device-assignment-card {
  padding: 0;
}
::ng-deep mat-card.org-device-assignment-card mat-card-content {
  padding: 0;
  margin: 0;
  height: 100%;
}

.card-header {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: var(--panel-color-default);
}
.card-header .section-label {
  font-family: var(--font-family-default);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-normal);
  line-height: 24px;
  color: var(--brand-color-main);
}

.assignment-grid {
  display: grid;
  grid-template-columns: minmax(180px, 260px) 1px 1fr;
  height: 100%;
}

.panel {
  padding: 8px 16px;
  overflow-y: auto;
}

.panel-divider {
  background-color: rgba(0, 0, 0, 0.12);
}

.panel-title {
  font-family: var(--font-family-default);
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-bold, 600);
  color: rgba(0, 0, 0, 0.6);
  padding: 8px 0 4px;
}

.panel-subtitle {
  font-weight: var(--font-weight-normal);
  color: rgba(0, 0, 0, 0.38);
}

.org-list {
  padding: 0;
}

.empty-state {
  color: rgba(0, 0, 0, 0.38);
  font-size: var(--font-size-default);
  padding: 16px 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/org-device-assignment/org-device-assignment.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;EACE,UAAA;EACA,SAAA;EACA,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,4CAAA;AAAF;AAEE;EACE,uCAAA;EACA,iCAAA;EACA,sCAAA;EACA,iBAAA;EACA,8BAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mDAAA;EACA,YAAA;AADF;;AAIA;EACE,iBAAA;EACA,gBAAA;AADF;;AAIA;EACE,qCAAA;AADF;;AAIA;EACE,uCAAA;EACA,mCAAA;EACA,yCAAA;EACA,yBAAA;EACA,kBAAA;AADF;;AAIA;EACE,sCAAA;EACA,0BAAA;AADF;;AAIA;EACE,UAAA;AADF;;AAIA;EACE,0BAAA;EACA,mCAAA;EACA,eAAA;AADF","sourcesContent":["::ng-deep mat-card.org-device-assignment-card {\n  padding: 0;\n\n  mat-card-content {\n    padding: 0;\n    margin: 0;\n    height: 100%;\n  }\n}\n\n.card-header {\n  display: flex;\n  align-items: center;\n  padding: 8px 16px;\n  background-color: var(--panel-color-default);\n\n  .section-label {\n    font-family: var(--font-family-default);\n    font-size: var(--font-size-large);\n    font-weight: var(--font-weight-normal);\n    line-height: 24px;\n    color: var(--brand-color-main);\n  }\n}\n\n.assignment-grid {\n  display: grid;\n  grid-template-columns: minmax(180px, 260px) 1px 1fr;\n  height: 100%;\n}\n\n.panel {\n  padding: 8px 16px;\n  overflow-y: auto;\n}\n\n.panel-divider {\n  background-color: rgba(0, 0, 0, 0.12);\n}\n\n.panel-title {\n  font-family: var(--font-family-default);\n  font-size: var(--font-size-default);\n  font-weight: var(--font-weight-bold, 600);\n  color: rgba(0, 0, 0, 0.6);\n  padding: 8px 0 4px;\n}\n\n.panel-subtitle {\n  font-weight: var(--font-weight-normal);\n  color: rgba(0, 0, 0, 0.38);\n}\n\n.org-list {\n  padding: 0;\n}\n\n.empty-state {\n  color: rgba(0, 0, 0, 0.38);\n  font-size: var(--font-size-default);\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
